/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmExtractCreateSchema } from "../../funcs/llmExtractCreateSchema.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateExtractSchemaRequest$inboundSchema,
};

export const tool$llmExtractCreateSchema: ToolDefinition<typeof args> = {
  name: "llm-extract-create-schema",
  description: `Create reusable extraction schema template

Creates and stores a reusable JSON Schema template for structured data extraction.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmExtractCreateSchema(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
